var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6C0 2.68629 2.68629 0 6 0C9.31369 0 12 2.68629 12 6C12 9.31369 9.31369 12 6 12C2.68629 12 0 9.31369 0 6ZM6 1C3.23858 1 1 3.23858 1 6C1 8.76141 3.23858 11 6 11C8.76141 11 11 8.76141 11 6C11 3.23858 8.76141 1 6 1Z",
    fill: "#459952"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.35359 4.35359L5.85359 7.85359C5.65833 8.04885 5.34175 8.04885 5.14648 7.85359L3.14648 5.85359L3.85359 5.14648L5.50004 6.79293L8.64648 3.64648L9.35359 4.35359Z",
    fill: "#459952"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.c15adc08646bab0fe594141ae61b4f9d.svg";
export { ForwardRef as ReactComponent };